<template>
  <v-container fluid>
    <v-card elevation="1">
      <v-toolbar color="secondary" dark shaped>
        <h3 class="title">{{$route.name}}</h3>
      </v-toolbar>
      <v-card-text style="padding:20px">
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  label="Fornecedor:"
                  :rules="fieldRules"
                  :items="providers"
                  item-value="provider_id"
                  item-text="provider_name"
                  v-model="data.provider_id"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="Data Inicial:" v-mask-date.br v-model="data.bill_start_date" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="Data Final:" v-mask-date.br v-model="data.bill_end_date" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Total de Litros:"
                  v-mask-decimal.br="2"
                  v-model="data.bill_total_litters"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="Acréscimo:" v-model="data.bill_added" v-mask-decimal.br="2" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="Desconto:" v-mask-decimal.br="2" v-model="data.bill_discount" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Valor Total:"
                  v-mask-decimal.br="2"
                  v-model="data.bill_total_value"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Total Atualizado:"
                  v-mask-decimal.br="2"
                  v-model="data.bill_total_updated"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Total Pago:"
                  v-mask-decimal.br="2"
                  v-model="data.bill_payment_value"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="N. Nota Fiscal:" v-model="data.bill_nfe_number" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Data Emissão NFE:"
                  v-mask-date.br
                  v-model="data.bill_nfe_emission"
                />
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <v-text-field label="Chave NFE:" v-model="data.bill_nfe_key" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="N.Empenho:" v-model="data.bill_interest" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Data do Empenho:"
                  v-mask-date.br
                  v-model="data.bill_interest_date"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea label="Histórico:" v-model="data.bill_history" />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea label="Observaçōes:" v-model="data.bill_obs" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-select
                  label="Status:"
                  v-model="data.bill_status"
                  :items="['ABERTO','FATURADO','EMPENHADO','PAGO']"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-footer style="padding:10px">
        <v-spacer />
        <v-btn
          :disabled="!valid && loader"
          depressed
          large
          color="primary"
          class="mr-4"
          :loading="loader"
          @click="validate"
        >Confirmar</v-btn>
      </v-footer>
    </v-card>
    <v-snackbar multi-line :color="snack.color" v-model="snack.show" transition="fade-transition">
      {{snack.message}}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Helpers from "../../mixins/helpers";
export default {
  props: ["id"],
  mixins: [Helpers],
  data: () => ({
    valid: false,
    loader: false,
    prefectures: [],
    providers: [],
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      bill_id: null,
      bill_start_date: null,
      bill_end_date: null,
      bill_total_litters: null,
      bill_added: null,
      bill_discount: null,
      bill_total_value: null,
      bill_total_updated: null,
      bill_payment_value: null,
      bill_nfe_number: null,
      bill_nfe_emission: null,
      bill_nfe_key: null,
      bill_interest: null,
      bill_interest_date: null,
      bill_payment_number: null,
      bill_payment_date: null,
      bill_history: null,
      bill_obs: null,
      bill_status: null,
      provider_id: null,
    },
  }),
  created() {
    this.Helpers;
    this.$http.get("/providers").then((r) => (this.providers = r.data));
    if (this.id) {
      this.loader = true;
      this.$store.dispatch("setLoader", true);
      this.$http.get(`/billings/${this.id}`).then((r) => {
        this.data = r.data[0];
        this.data.bill_start_date = this.convertDate(r.data[0].bill_start_date);
        this.data.bill_end_date = this.convertDate(r.data[0].bill_end_date);
        this.data.bill_nfe_emission = this.convertDate(
          r.data[0].bill_nfe_emission
        );
        this.data.bill_interest_date = this.convertDate(
          r.data[0].bill_interest_date
        );
        this.$http.get(`/providers/${this.data.provider_id}`).then(() => {
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        });
      });
    }
  },
  methods: {
    validate() {
      this.snack.show = true;
      this.loader = true;
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message =
          "Atencão um ou mais campos precisam ser preenchidos!";
        this.loader = false;
      }
    },
    createOrUpdate() {
      this.loader = true;
      if (this.id) {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .put(`/billings/${this.id}`, this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            setTimeout(() => {
              this.loader = false;
              this.$store.dispatch("setLoader", this.loader);
              window.location.reload(1);
            }, 1500);

          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style>
.title {
  text-transform: uppercase;
  font-weight: 400;
}

.flexd {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.flexd p {
  margin: 10px 0;
  font-weight: bold;
  text-transform: uppercase;
}
</style>